import { render } from "./DashobardOrderStatusPage.vue?vue&type=template&id=5eaa5427"
import script from "./DashobardOrderStatusPage.vue?vue&type=script&lang=js"
export * from "./DashobardOrderStatusPage.vue?vue&type=script&lang=js"

import "./DashobardOrderStatusPage.vue?vue&type=style&index=0&id=5eaa5427&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__